import { action, observable, makeObservable } from 'mobx';

class BooleanStore {
  @observable
  value: boolean;

  constructor(defValue: boolean = false) {
    makeObservable(this);
    this.value = defValue;
  }

  @action
  on() {
    this.value = true;
  }

  @action
  off() {
    this.value = false;
  }

  @action
  toogle() {
    this.value = !this.value;
  }
}

export { BooleanStore };
